<template>
  <div
    class="harness-accordion-group"
    :class="{ active: isSelected }"
  >
    <button
      class="header"
      @click="selectGroup"
    >
      <accordion-caret :is-open="isSelected" />
      {{ group.key }}
    </button>

    <ul v-if="isSelected">
      <accordion-group-value
        v-for="m in group.members"
        :key="m"
        :id="m"
        :is-selected="selectedQuestion != null && selectedQuestion.id === m"
        :would-replace-selection="selectedQuestion !== null && selectedQuestion.id !== m"
        :get-value-properties="getValueProperties"
        :use-sub-selection="useSubSelection"
        :selected-levels="selectedLevels"
        :search-string="searchString"
        :is-expanded="expandedQuestion === m"
        @onToggleExpansion="$emit('onExpandQuestion', { id: m, ...$event })"
        @onSelectQuestion="$emit('onSelectQuestion', { id: m, ...$event })"
      />
    </ul>
  </div>
</template>

<script>
import AccordionCaret from './AccordionCaret.vue'
import AccordionGroupValue from './AccordionGroupValue.vue'
export default {
  components: { AccordionGroupValue, AccordionCaret },
  name: 'AccordionGroup',
  props: {
    group: {
      type: Object,
      default: () => ({
        key: null,
        members: []
      })
    },
    getValueProperties: {
      type: Function,
      default: null
    },
    isSelected: Boolean,
    selectedValue: {
      type: String,
      default: null
    },
    expandedQuestion: {
      type: String,
      default: null
    },
    useSubSelection: {
      type: Boolean,
      default: false
    },
    selectedQuestion: {
      type: Object,
      default: null
    },
    selectedLevels: {
      type: Object,
      default: null
    },
    searchString: {
      type: String,
      default: null
    }
  },
  methods: {
    selectGroup () {
      this.$emit('onExpandGroup')
    }
  },
  emits: [
    'onExpandGroup',
    'onExpandQuestion',
    'onSelectQuestion'
  ]
}
</script>

<style lang="scss" scoped>
.harness-accordion-group {
    transition: background-color 400ms ease;

    .header {
      width: 100%;
      background: #fff;

      font-family: Merriweather, bold;
      color: #575757;
      font-size: 14.5px;
      font-weight: bold;

      border: 0px;
      border-bottom: 1px dotted #aaa;

      padding: 4px;
      padding-left: 16px;

      display: flex;
      align-items: center;
      letter-spacing: .02em;
      column-gap: 8px;
    }

    .header:hover {
      background-color: #bed8ea;
    }

    &.active .header {
        color: #575757;
    }

    ul {
        padding: 4px 16px;
        background-color: #fff;

        list-style: none;
    }
}
</style>
